module.exports = {
  name: 'int',
  ampContent: 'http://int.hmhone.app.hmhco.com/content',
  ampLoggedInURL: 'http://int.hmhone.app.hmhco.com/ui/logged-in/',
  ampLogin: 'http://int.hmhone.app.hmhco.com/ui/login/',
  ampLoginHelp: 'http://downloads.hmlt.hmco.com/Help/Ed/LogIn',
  ampLoginPrivacyPolicy:
    'https://www.hmhco.com/prek-12-products-privacy-policy',
  ampLoginTermsAndConditions:
    'https://www.hmhco.com/terms-of-use-k12-learning-platforms',
  apiEngHostname: 'https://api.int.br.internal',
  apiEngHostnamePublic: 'https://api.int.br.internal',
  assessments: 'http://int.hmhone.app.hmhco.com/api/assessment',
  assignments: 'http://int.hmhone.app.hmhco.com/api/assignment',
  authorizationApi: 'http://int.hmhone.app.hmhco.com/api/authorization',
  auth0: 'https://hmhco-eng.auth0.com',
  auth0CreateConnectionsHost:
    'http://auth-self-service-setup.int.br.hmheng.io/api/v1/sso',
  auth0FetchConnectionsHost:
    'http://auth-self-service-setup.int.br.hmheng.io/api/v1/sso/datastore/connection',
  baseURL: 'http://int.hmhone.app.hmhco.com',
  classes: 'http://int.hmhone.app.hmhco.com/ui/classes',
  classesClasses: 'http://int.hmhone.app.hmhco.com/ui/classes/classes',
  clientRegistry: 'https://api.int.eng.hmhco.com/idm-client-registry',
  contentPickerAMP: 'http://int.hmhone.app.hmhco.com/ui/#/picker',
  contentProvider: 'http://int.hmhone.app.hmhco.com/ui/#/contentProvider/',
  ctsDistrictLogin: 'http://int.hmhone.app.hmhco.com/ui/login/?connection=',
  districtDownloadApi:
    'https://data-district-download-service.staging0.hmheng-ds.br.internal',
  ebrCore: 'https://api.int.br.internal/idm-ebr-core',
  ebrUi: 'http://int.hmhone.app.hmhco.com/ebr/',
  edContent: 'http://int.hmhone.app.hmhco.com/content',
  edDistrictLogin: 'http://int.hmhone.app.hmhco.com/ui/login/?connection=',
  edHostname: 'http://int.hmhone.app.hmhco.com/',
  edLoggedInURL: 'http://int.hmhone.app.hmhco.com/ui/logged-in',
  edLogin: 'http://int.hmhone.app.hmhco.com/ui/login/',
  edRoot: 'http://int.hmhone.app.hmhco.com/ui/#/',
  EDSLoginUrl: 'https://hapi.int.hmhco.com/edcore/eds-login',
  EDSResourceUrl:
    'https://app01.int.tsg.hmhco.com/edcore/hmheng-eds-api-gateway',
  forgotPassword: 'http://int.hmhone.app.hmhco.com/ui/login/forgot-password/',
  grading: 'http://int.hmhone.app.hmhco.com/api/grading/',
  hmhHelpCenter: 'http://downloads.hmlt.hmco.com',
  hmoHostname: 'http://my-test.hrw.com/access/',
  hmoLoginPath: 'http://my-test.hrw.com/index.jsp',
  idm: 'http://int.app.sif.identity.api.hmhco.com/openid-connect',
  jasperReporting: 'https://int.hmhone.app.hmhco.com/jasperserver-pro',
  licensing: 'http://int.hmhone.app.hmhco.com/ui/#/licenses',
  liftRoot: 'http://int.hmhone.app.hmhco.com/ui/',
  loginPath: '/ui/login/',
  myClasses: 'http://int.hmhone.app.hmhco.com/ui/!my-classes',
  myStuff: 'http://int.hmhone.app.hmhco.com/ui/#/my-stuff/lessons',
  notificationsApi: 'https://api.int.eng.hmhco.com',
  oktaConnectionApi:
    'https://api.int.br.internal/okta-services-gateway/api/v1/sso',
  oktaFetchConnectionsHost:
    'https://api.int.br.internal/okta-services-gateway/api/v1/sso/idps',
  oktaNewOrg: 'https://int.hmhco.com/okta-services-gateway/api/v1/org', // this is deliberate to prevent a 401 logout on int
  onesearch: 'http://int.hmhone.app.hmhco.com/api/onesearch/v1',
  picker: 'http://int.hmhone.app.hmhco.com/ui/#/picker/',
  plannerHost: 'https://planner-api.staging0.hmheng-csl.br.internal',
  plannerHostNonWaf: 'https://planner-api.staging0.hmheng-csl.br.internal',
  plsAuthors:
    'https://api.int.eng.hmhco.com/pls-services-author/api/v5/authors',
  plsLessonRelatedResource:
    'https://api.int.eng.hmhco.com/pls-services-lessonrelatedresource/api/v5/lessonrelatedresources',
  plsRelatedResources:
    'https://api.int.eng.hmhco.com/pls-services-relatedresource/api/v5/relatedresources',
  plsResource:
    'https://api.int.eng.hmhco.com/pls-services-resource/api/v5/resources',
  edsApiGateway: 'https://hapi.int.hmhco.com/edcore/hmheng-eds-api-gateway/',
  prefixCDS: 'http://cds-metadatapipeline.int.br.hmheng.io',
  productLanding: 'http://int.hmhone.app.hmhco.com/ui/#/product',
  restApi: 'https://api.int.eng.hmhco.com',
  restHapi: 'https://hapi.int.hmhco.com',
  restDMPS: 'https://api.int.br.internal/dmps',
  restDMPSNonWAF: 'https://api.int.br.internal/dmps',
  restELM: 'https://api.int.br.internal/elm/v1',
  restIdsApi: 'https://api.int.br.internal/ids', // for purging users in IDS we need a different API
  restIdsGridApi: 'https://api.int.br.internal/ids-grid-api',
  restIdsGridApiNonWAF: 'https://api.int.br.internal/ids-grid-api',
  restNotifications: 'https://api.int.eng.hmhco.com/notifications',
  restNotificationsNonWAF: 'https://api.int.eng.hmhco.com/notifications',
  restOAC: 'https://api.int.br.internal/oac/v3',
  restOACNonWAF: 'https://api.int.br.internal/oac/v3',
  restPostPrefix: 'http://int.hmhone.app.hmhco.com',
  restPrefix: 'http://int.hmhone.app.hmhco.com',
  restRecommendation: 'https://api.int.br.internal/recommendation-api',
  restStagingProcessor: 'https://api.int.br.internal/idm-staging-processor',
  restSusApi: 'https://api.int.br.internal/idm-user-api', // for purging users in SUS
  restUdsApi: 'https://api.int.eng.hmhco.com/uds',
  restUpdatesApi: 'https://api.int.eng.hmhco.com/update-catalog',
  rosterDashboard: 'http://int.hmhone.app.hmhco.com/ui/#/roster',
  r180Api: 'https://int.hmhone.app.hmhco.com/api/r180/',
  r180Media: 'https://int.hmhone.app.hmhco.com/r180/media',
  sisHostname: 'http://int.hmhone.app.hmhco.com/',
  sso: 'http://auth-self-service-setup.int.br.hmheng.io',
  storyBook: 'http://int.hmhone.app.hmhco.com/ui/storybook/',
  susAuth: 'http://int.hmhone.app.hmhco.com/api/authorization',
  tcHostname: 'http://www-int.thinkcentral.com/access/',
  tcLoginPath: 'http://www-int.thinkcentral.com/ePC/start.do',
  teacherDashboard: 'http://int.hmhone.app.hmhco.com/ui/',
  linkedAssignments:
    'http://int.hmhone.app.hmhco.com/ui/#/assign-full?resourceId=l_ff9bdd36-f627-4241-8dbc-9f9b4f158f56_c7b06f27-597b-42fc-8169-67247568e97f&programId=IM_NL20_G4&title=Unit+Opener%3A+Place+Value+and+Whole+Number+Operations&backTo=discover%252FIM_NL20_G4%252F1&showSched=true&recBy=NONE&isSgm=false',
  virtualClassroom: 'http://int.hmhone.app.hmhco.com/ui/#/virtual-classroom',
  virtualClassroomApi:
    'https://api.int.eng.hmhco.com/vcservice/v2/virtual-classroom/meeting',
  wormhole: 'https://api.int.br.internal/wh-api/graphql',
  importingService: 'https://api.int.br.internal/idm-api-importing-service',
};
